import { useContext } from 'react';
import AuthContext from '../contexts/authContext';

export const usePermissions = () => {
	const { userPermissions, isLoading } = useContext(AuthContext);

	const hasPermission = (permission: string): boolean => {
		if (isLoading) return false;
		return userPermissions.includes(permission);
	};

	const hasAnyPermission = (permissions: string[]): boolean => {
		if (isLoading) return false;
		return permissions.some(permission => userPermissions.includes(permission));
	};

	const hasAllPermissions = (permissions: string[]): boolean => {
		if (isLoading) return false;
		return permissions.every(permission => userPermissions.includes(permission));
	};

	const hasHierarchicalPermission = (childPermission: string, parentPermission: string): boolean => {
		if (isLoading) return false;
		// User must have both the parent permission AND the child permission
		return userPermissions.includes(parentPermission) && userPermissions.includes(childPermission);
	};

	return {
		userPermissions,
		isLoading,
		hasPermission,
		hasAnyPermission,
		hasAllPermissions,
		hasHierarchicalPermission,
	};
};

export default usePermissions;
